export const gridThemeLight = {
  bgCell:            '#FFFFFF',
  bgCellMedium:      '#F5F6F7',
  bgHeader:          '#F0F1F2',
  bgHeaderHasFocus:  '#E4E6E9',
  bgHeaderHovered:   '#E4E6E9',
  textHeader:        '#5F6770',
  textDark:          '#1B1F24',
  textMedium:        '#4A5260',
  textLight:         '#858E99',
  textBubble:        '#4A5260',
  bgBubble:          '#EBEDF0',
  bgBubbleSelected:  '#DFE1E5',
  borderColor:       '#E1E4E8',
  drilldownBorder:   '#CDD0D5',
  accentColor:       '#1A5C6B',
  accentFg:          '#FFFFFF',
  accentLight:       'rgba(26,92,107,0.10)',
  cellHorizontalPadding: 10,
  cellVerticalPadding:   6,
  headerFontStyle:   '600 12px',
  baseFontStyle:     '13px',
  fontFamily:        "'Geist', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  lineHeight:        1.5,
  headerIconSize:    16,
  markerFontStyle:   '11px',
  editorFontSize:    '13px',
  lineWidth:         1,
  roundingRadius:    4,
}

export const gridTheme = {
  bgCell: '#1B1F24',
  bgCellMedium: '#252B32',
  bgHeader: '#252B32',
  bgHeaderHasFocus: '#2D343C',
  bgHeaderHovered: '#2D343C',
  textHeader: '#858E99',
  textDark: '#F2F4F6',
  textMedium: '#BEC5CD',
  textLight: '#5F6770',
  textBubble: '#BEC5CD',
  bgBubble: '#252B32',
  bgBubbleSelected: '#2D343C',
  borderColor: '#2A3038',
  drilldownBorder: '#353D46',
  accentColor: '#1A5C6B',
  accentFg: '#E8F8FB',
  accentLight: 'rgba(26,92,107,0.18)',
  cellHorizontalPadding: 10,
  cellVerticalPadding: 6,
  headerFontStyle: '600 12px',
  baseFontStyle: '13px',
  fontFamily: "'Geist', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  lineHeight: 1.5,
  headerIconSize: 16,
  markerFontStyle: '11px',
  editorFontSize: '13px',
  lineWidth: 1,
  roundingRadius: 4,
}
